export const FETCH_FREEBETS = `
  query FetchFreebets(
    $playerId: String!
    $operatorId: String!
    $brandId: String
    $status: [String]
    $size: Int
    $page: Int
    $gameCode: String
  ) {
    players {
      fetchFreebets(
        playerId: $playerId
        operatorId: $operatorId
        brandId: $brandId
        status: $status
        size: $size
        page: $page
        gameCode: $gameCode
      ) {
        status
        success
        message
        code
        data {
          activeFreebetscount
          userFreebets {
            id
            playerId
            operatorId
            brandId
            currency
            numberOfFreeBetsToAward
            numberOfFreeBetsUsed
            freeBetBetAmount
            status
            playerFreebetId
            createdAt
            claimedAt
            expiringAt
            source
            jackpotRatio
            winAmount
            packageId
          }
        }
      }
    }
  }
`

export const GET_FREEBETS_COUNT_ON_STATUS = `
  query FreebetsCount(
    $playerId: String!
    $operatorId: String!
    $brandId: String
    $status: [String]
    $gameCode: String
  ) {
    players {
      getFreebetsCountOnStatus(
        playerId: $playerId
        operatorId: $operatorId
        brandId: $brandId
        status: $status
        gameCode: $gameCode
      ) {
        status
        success
        message
        code
        data {
          activeFreebetscount
          status
        }
      }
    }
  }
`
